import k from '../constants/k'
import player from '../components/player'
import arrow from '../components/arrow'
import useInventory from '../components/inventory'
import { mouse, addHoverEffect } from '../components/mouse'
import { addIngredient } from '../components/ingredient'
import book from '../components/book'

k.loadSprite('garden-background', 'sprites/backgrounds/garden.png')

k.loadSprite('roses', 'sprites/ingredients/roses.png')
k.loadSprite('beehive', 'sprites/ingredients/beehive.png')

export default () => {
  k.add([k.sprite('garden-background'), k.area(), 'background'])
  const { cursor } = mouse()
  const inventory = useInventory(cursor)
  book(cursor)

  const roses = k.add([
    k.sprite('roses'),
    k.area(),
    k.pos(150, 61),
    k.scale(1),
    k.anchor('center')
  ])
  addHoverEffect(roses, cursor)
  roses.onClick(() => addIngredient(inventory, 'rose'))

  const beehive = k.add([
    k.sprite('beehive'),
    k.area(),
    k.pos(33, 48),
    k.scale(1),
    k.anchor('center')
  ])
  addHoverEffect(beehive, cursor)
  beehive.onClick(() => addIngredient(inventory, 'honey'))

  player()

  arrow('left', 'room', cursor)
  arrow('right', 'forest', cursor)
}
